import { graphql } from "../generated";

export const LinkTagsToCall = graphql(`
  mutation LinkTagsToCall($input: LinkTagsToCallInput!) {
    linkTagsToCall(input: $input) {
      id
    }
  }
`);
